import React from 'react'
import AllValvulaChart from "../../Components/AllValvulaChart"

function Index() {
  return (
    <div id='divChart'>
      <AllValvulaChart />
    </div>
  )
}

export default Index